import {FaFacebookF, FaInstagram,FaTwitter,FaLinkedin, FaDribbble} from '../assets/icons/vander'

import portfolio1 from '../assets/images/portfolio/01.jpg'
import portfolio2 from '../assets/images/portfolio/02.jpg'
import portfolio3 from '../assets/images/portfolio/03.jpg'
import portfolio4 from '../assets/images/portfolio/04.jpg'
import portfolio5 from '../assets/images/portfolio/05.jpg'
import portfolio6 from '../assets/images/portfolio/06.jpg'
import portfolio7 from '../assets/images/portfolio/07.jpg'
import portfolio8 from '../assets/images/portfolio/08.jpg'
import portfolio9 from '../assets/images/portfolio/09.jpg'
import portfolio10 from '../assets/images/portfolio/10.jpg'
import portfolio11 from '../assets/images/portfolio/11.jpg'
import portfolio12 from '../assets/images/portfolio/12.jpg'
import portfolio13 from '../assets/images/portfolio/13.jpg'
import portfolio14 from '../assets/images/portfolio/14.jpg'
import portfolio15 from '../assets/images/portfolio/15.jpg'
import portfolio16 from '../assets/images/portfolio/16.jpg'
import portfolio17 from '../assets/images/portfolio/17.jpg'
import portfolio18 from '../assets/images/portfolio/18.jpg'

export const portfolioData = [
    {
        id:1,
        image:portfolio1,
        title:'The Leaf and Letter',
        name:'Branding',
        category:'branding'
    },
    {
        id:2,
        image:portfolio2,
        title:'The Papers',
        name:'Designing',
        category:'designing'
    },
    {
        id:3,
        image:portfolio3,
        title:'The Headphones',
        name:'Photography',
        category:'photography'
    },
    {
        id:4,
        image:portfolio4,
        title:'The Projects',
        name:'Development',
        category:'development'
    },
    {
        id:5,
        image:portfolio5,
        title:'The Cup of Coffee',
        name:'Branding',
        category:'branding'
    },
    {
        id:6,
        image:portfolio6,
        title:'The Pen and Books',
        name:'Designing',
        category:'designing'
    },
    {
        id:7,
        image:portfolio7,
        title:'The Strawberry',
        name:'Photography',
        category:'photography'
    },
    {
        id:8,
        image:portfolio8,
        title:'The Leaf and Books',
        name:'Development',
        category:'development'
    },
    {
        id:9,
        image:portfolio9,
        title:'The Cactus Plant',
        name:'Branding',
        category:'branding'
    },
    {
        id:10,
        image:portfolio10,
        title:'The Yellow Bag',
        name:'Photography',
        category:'photography'
    },
    {
        id:11,
        image:portfolio11,
        title:'The Teapot Table',
        name:'Designing',
        category:'designing'
    },
    {
        id:12,
        image:portfolio12,
        title:'The Orange',
        name:'Development',
        category:'development'
    },
]
export const portfolioImg = [
    portfolio1,portfolio2,portfolio3,portfolio4,portfolio5,portfolio6,portfolio7,portfolio8,portfolio9,portfolio10,portfolio11,portfolio12,
]

export const masonaryData = [
    {
        id:1,
        image:portfolio1,
        title:'The Leaf and Letter',
        name:'Branding',
        category:'branding'
    },
    {
        id:2,
        image:portfolio17,
        title:'The Papers',
        name:'Designing',
        category:'designing'
    },
    {
        id:3,
        image:portfolio13,
        title:'The Headphones',
        name:'Photography',
        category:'photography'
    },
    {
        id:4,
        image:portfolio10,
        title:'The Projects',
        name:'Development',
        category:'development'
    },
    {
        id:5,
        image:portfolio3,
        title:'The Cup of Coffee',
        name:'Branding',
        category:'branding'
    },
    {
        id:6,
        image:portfolio18,
        title:'The Pen and Books',
        name:'Designing',
        category:'designing'
    },
    {
        id:7,
        image:portfolio14,
        title:'The Strawberry',
        name:'Photography',
        category:'photography'
    },
    {
        id:8,
        image:portfolio9,
        title:'The Leaf and Books',
        name:'Development',
        category:'development'
    },
    {
        id:9,
        image:portfolio2,
        title:'The Cactus Plant',
        name:'Branding',
        category:'branding'
    },
    {
        id:10,
        image:portfolio16,
        title:'The Yellow Bag',
        name:'Photography',
        category:'photography'
    },
    {
        id:11,
        image:portfolio15,
        title:'The Teapot Table',
        name:'Designing',
        category:'designing'
    },
    {
        id:12,
        image:portfolio11,
        title:'The Orange',
        name:'Development',
        category:'development'
    },
]

export const masonaryImg = [
    portfolio1,portfolio17,portfolio13,portfolio10,portfolio3,portfolio18,portfolio14,portfolio9,portfolio2,portfolio16,portfolio15,portfolio11
]

export const social = [
    FaFacebookF,FaInstagram,FaTwitter,FaLinkedin,FaDribbble
]